$shm_hitalama_settings_transfer $mol_list
	rows /
		<= Export_all $mol_button_download
			blob <= exported_blob null
			file_name <= exported_file_name \hitalama-maps.json
			title \Экспорт всех карт
		<= Import_all $shm_button_open
			title \Импорт всех карт
			multiple false
			files? <=> import_files? /File
		<= Status $mol_text
			text <= status? \
